module.exports = __webpack_public_path__ + "static/media/build_muscle_icon.aadad0cc.svg";